import dayjs from 'dayjs'
import { Controller } from 'react-hook-form'

import Flex from '@/elements/Flex'
import Form from '@/elements/Form'
import FormInput from '@/elements/FormInput'
import FormDatePicker from '@/elements/FormDatePicker'
import type useIndividualSponsorshipForm from '@/hooks/forms/useIndividualSponsorshipForm'

function IndividualSponsorshipForm(
  form: ReturnType<typeof useIndividualSponsorshipForm>['form']
) {
  return (
    <Form>
      <Flex className='form-group'>
        <Controller
          name='name'
          control={form.control}
          render={({ field }) => (
            <FormInput
              {...field}
              label='Brand Name'
              placeholder='e.g. Pepsi'
              error={form.formState.errors.name?.message}
              dirty={!!form.formState.dirtyFields.name}
            />
          )}
        />
        <Controller
          control={form.control}
          name='url'
          render={({ field }) => (
            <FormInput
              {...field}
              label='URL'
              type='url'
              placeholder='https://link.com'
              error={form.formState.errors.url?.message}
              dirty={!!form.formState.dirtyFields.url}
            />
          )}
        />
      </Flex>
      <Flex className='form-group'>
        <Controller
          control={form.control}
          name='beginningDate'
          render={({ field }) => (
            <FormDatePicker
              {...field}
              value={field.value ? dayjs(field.value).toDate() : null}
              onChange={date => field.onChange(date ? dayjs(date) : null)}
              label='Starting Date'
              placeholder='Select a date'
              error={form.formState.errors.beginningDate?.message}
              dirty={!!form.formState.dirtyFields.beginningDate}
            />
          )}
        />
        <Controller
          control={form.control}
          name='endDate'
          render={({ field }) => (
            <FormDatePicker
              {...field}
              value={field.value ? dayjs(field.value).toDate() : null}
              onChange={date => field.onChange(date ? dayjs(date) : null)}
              label='End Date'
              placeholder='Select a date'
              error={form.formState.errors.endDate?.message}
              dirty={!!form.formState.dirtyFields.endDate}
            />
          )}
        />
      </Flex>
    </Form>
  )
}

export default IndividualSponsorshipForm
